import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {ROUTE_NAMES} from "../../../core/consts";
import {APP} from "../../../core/app/consts";
import {BolaoLinkParams} from "./bolao-link-params";

export class BolaoLinkModel extends BaseLinkModel {
  screen: APP.ANALYTICS.SOURCES.bolao;

  constructor() {
    super(ROUTE_NAMES.bolao, new BolaoLinkParams());
  }
}
